import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { URLConfig } from "../network/urlStore";
import { IApplicationConfigResponse } from "../models/IApplication.model";

export const getApplicationConfig = (): Observable<IApplicationConfigResponse> => {
  const url = URLConfig.getApplicationConfigURL();
  
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IApplicationConfigResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching application config", error);
      }
    );
  });
};
